/**
 * Unified Loading Spinner Component
 * Thick, solid, smooth spinner for consistent loading states across the app
 */

export function Spinner({ size = "default", className = "" }) {
  const sizeClasses = {
    sm: "h-6 w-6 border-[3px]",
    default: "h-12 w-12 border-4",
    lg: "h-16 w-16 border-[5px]",
    xl: "h-20 w-20 border-[6px]"
  };

  return (
    <div
      className={`
        ${sizeClasses[size] || sizeClasses.default}
        rounded-full
        border-solid
        border-[#EA5B25]
        border-t-transparent
        animate-spin
        ${className}
      `}
      style={{
        animationDuration: "0.8s",
        animationTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)"
      }}
      role="status"
      aria-label="Loading"
    />
  );
}

export function PageSpinner() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Spinner size="lg" />
    </div>
  );
}

export function FullPageSpinner() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
      <Spinner size="xl" />
    </div>
  );
}

export default Spinner;
